
import { Calendar } from "lucide-react";

export function AppointmentLink() {
  return (
    <div className="bg-primary/10 p-6 rounded-lg flex justify-center items-center shadow-sm mb-8">
      <a 
        href="https://cal.com/web-star/15min" 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex items-center text-primary hover:text-primary/80 transition-colors gap-3"
      >
        <Calendar className="h-6 w-6" />
        <span className="font-medium text-lg">Κράτηση Ραντεβού</span>
      </a>
    </div>
  );
}
